import { __assign, __rest } from "tslib";
import React from 'react';
import { TextField as MaterialTextField, } from '@material-ui/core';
import { useDeprecationWarning } from '../internal/useDeprecationWarning';
export var TextField = React.forwardRef(function (_a, ref) {
    var props = __rest(_a, []);
    useDeprecationWarning(TextField.name, 'Please use the `Input` component instead.');
    return React.createElement(MaterialTextField, __assign({}, props, { ref: ref }));
});
//# sourceMappingURL=TextField.js.map